import { useNavigate, useParams } from 'react-router-dom';
import { completeRegistration } from '../../api/registrationCompletionCheck';
import { unauthenticatedPaths } from '../../router/constants/route-paths';
import { FormWithPasswordMeter } from './PasswordForms/FormWithPasswordMeter';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { validateExternalSupervisorRegistrationCompletionCode } from '../../api/externalSupervisorInvitation';
import { useEffect } from 'react';

const NewPassword = () => {
    const navigate = useNavigate();

    const localization = useSelector(
        (state: RootState) =>
            state.localization.localizationStrings.susy.authentication
                .newPassword
    );

    const { code } = useParams();

    if (!code || code.length === 0) {
        navigate(unauthenticatedPaths.signIn);
        return <></>;
    }

    useEffect(() => {
        const checkCode = async (codeForValidation: string) => {
            try {
                await validateExternalSupervisorRegistrationCompletionCode(
                    codeForValidation
                );
            } catch (err) {
                navigate(unauthenticatedPaths.signIn);
            }
        };

        checkCode(code);
    }, [code]);

    return (
        <FormWithPasswordMeter
            buttonText={localization.setPasswordBtn}
            onSubmit={async (password: string) =>
                await completeRegistration(code, password)
            }
        />
    );
};

export default NewPassword;
